import { useTranslation } from "react-i18next";
import { ExternalLink } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";

export function ClockPreviewModal({ url, onClose }) {
  const { t } = useTranslation();
  if (!url) return null;
  return (
    <Dialog open onOpenChange={(o) => { if (!o) onClose(); }}>
      <DialogContent className="max-w-[420px] gap-0 overflow-hidden p-0" data-testid="clock-preview-modal">
        <DialogHeader className="px-4 pt-4">
          <DialogTitle>{t("bau.previewTitle")}</DialogTitle>
          <DialogDescription className="text-xs text-slate-500">{t("bau.previewHint")}</DialogDescription>
        </DialogHeader>
        <div className="mx-4 my-3 overflow-hidden rounded-2xl border border-slate-200 bg-slate-50" style={{ height: "68vh" }}>
          <iframe src={url} title="clock-preview" className="h-full w-full border-0" data-testid="clock-preview-iframe" />
        </div>
        <div className="flex justify-end gap-2 border-t border-slate-100 px-4 py-3">
          <a href={url} target="_blank" rel="noreferrer">
            <Button variant="outline" className="rounded-full" data-testid="clock-preview-newtab"><ExternalLink className="mr-1 h-4 w-4" /> {t("bau.previewNewTab")}</Button>
          </a>
          <Button onClick={onClose} className="rounded-full bg-navy text-white hover:bg-navy-muted" data-testid="clock-preview-close">{t("bau.previewClose")}</Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
